module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#pre"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("My aim in this book is to discuss the question of creation and evolution from a biblical point of view, as a scholar who specializes in the Bible. There are many books on the question from a scientific point of view. Most scientists write from their area of expertise (though this is by no means always the case); few possess specialist knowledge of the Bible. When I talk about the Bible, I sometimes cite secondary literature, but most of the time I am working with primary sources: the Hebrew, Aramaic, and Greek texts of the Hebrew Bible and the New Testament, the Dead Sea Scrolls, the relevant early translations (the Greek translations of the Hebrew Bible [the Septuagint], and the targumim), and the range of early Jewish literature in a variety of languages. When a source in another modern or ancient language is quoted, the translation is mine unless otherwise indicated.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When I discuss the Bible, I do so as a specialist. Here and there, however, it will be necessary to bring up scientific material. In such cases, I have done my best to research the latest information and views, including consultation of books written by specialists, academic journals, and the opinions of experts. But I recognize that here I am not a specialist and can only pass on information from specialist sources. Nevertheless, I have expended a lot of time and effort to obtain up-to-date information and have also attempted to dig out the views of scientists who have a religious belief. The sources are indicated in the notes. I know that there will inevitably be some errors in my discussion; I only hope and trust that they are not fundamental to the argument. Professor Conway Morris kindly looked over some of the material and saved me from some mistakes (most of them small, happily), but "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("he is not responsible for any that remain. Otherwise, I present the results of my research in the expectation that any mistaken data will not invalidate the argument presented. No doubt expert reviewers will tell me if that is not the case.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, I wish to thank Trevor W. Thompson, acquisitions and development editor, and Michael N. Thomson, senior acquisitions editor at Eerdmans. Together we have worked hard to produce a book that will reach a wide audience, yet without compromising the integrity of the arguments or slighting the data needed to support those arguments. I can only hope that we have succeeded.")]), _vm._v(" "), _c('p', {
    staticClass: "RightSb1"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTER")]), _vm._v(" L. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RABBE")]), _c('br'), _vm._v("Kingston-upon-Hull, England")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc5c2a04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 69
// module chunks = 0